module.exports = __webpack_public_path__ + "static/img/featrue1.5e2c509f.jpg";